import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-minus",
  "use": "foquz-icon-minus-usage",
  "viewBox": "0 0 10 3",
  "content": "<symbol viewBox=\"0 0 10 3\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-minus\"><path d=\"M9 1.028H1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol